import { Seo } from "@/lib/seo";
import { PageHero } from "@/components/page-hero";

const SECCIONES: { titulo: string; parrafos: string[] }[] = [
  {
    titulo: "Responsable del tratamiento",
    parrafos: [
      "Tulevik Legal (el “Despacho”), con presencia en Texcoco, Estado de México, es responsable del tratamiento de los datos personales que recaba a través de este sitio web.",
      "Este aviso se publica en versión 1.0 y forma parte de las políticas del sitio. La versión vigente es siempre la publicada en esta página.",
    ],
  },
  {
    titulo: "Datos que recabamos",
    parrafos: [
      "A través del formulario de contacto y de la ruta de atención prioritaria recabamos: nombre, medio de contacto preferido, correo electrónico y/o teléfono, tema general del asunto, ubicación del asunto (ciudad o estado), fecha próxima si existe y una descripción breve opcional que tú decidas compartir.",
      "El orientador “Encuentra tu ruta” no recaba datos personales: sus respuestas no se guardan de forma identificable.",
    ],
  },
  {
    titulo: "Finalidades del tratamiento",
    parrafos: [
      "Usamos tus datos exclusivamente para: atender tu solicitud de contacto, clasificar tu asunto, contactarte por el medio que elegiste, gestionar la relación profesional en caso de contratación y, en su caso, cumplir obligaciones legales.",
      "No usamos tus datos para publicidad, no los vendemos ni los cedemos a terceros con fines comerciales.",
    ],
  },
  {
    titulo: "Proveedores y comunicación interna",
    parrafos: [
      "Las solicitudes se almacenan en sistemas del Despacho. Para el aviso interno de nuevas solicitudes puede utilizarse un proveedor de correo electrónico transaccional, que procesa la información únicamente para entregar ese aviso al Despacho.",
      "Las notificaciones internas contienen los datos del formulario; su envío es un proceso técnico con acceso restringido al equipo del Despacho.",
    ],
  },
  {
    titulo: "Conservación y seguridad",
    parrafos: [
      "Conservamos tus datos por el tiempo necesario para atender tu solicitud y, si hay relación profesional, conforme a los plazos aplicables a expedientes jurídicos. Los datos que no deriven en contratación se eliminan o anonimizan cuando dejan de ser necesarios.",
      "Aplicamos medidas de acceso restringido: la revisión de solicitudes requiere credenciales administrativas.",
    ],
  },
  {
    titulo: "Tus derechos (ARCO)",
    parrafos: [
      "Puedes solicitar el acceso, rectificación, cancelación u oposición del tratamiento de tus datos, así como revocar el consentimiento otorgado, escribiéndonos por el mismo formulario de contacto indicando el asunto “Aviso de privacidad”. Responderemos en los plazos que marca la ley aplicable en materia de protección de datos personales en México.",
    ],
  },
  {
    titulo: "Cambios al aviso",
    parrafos: [
      "Este aviso puede actualizarse. Cuando ocurra, publicaremos la nueva versión en esta página con su número de versión correspondiente.",
    ],
  },
];

export default function Privacidad() {
  return (
    <>
      <Seo
        title="Aviso de privacidad"
        description="Aviso de privacidad de Tulevik Legal: qué datos recabamos, para qué, cómo los protegemos y cómo ejercer tus derechos ARCO."
        path="/privacidad"
      />
      <PageHero
        eyebrow="Legal"
        titulo="Aviso de privacidad"
        lead="Versión 1.0 — aplicable al sitio público y a los formularios de contacto de Tulevik Legal."
      />
      <section className="bg-parchment">
        <div className="mx-auto max-w-3xl px-4 py-16 sm:px-8 sm:py-20">
          {SECCIONES.map((s, i) => (
            <Reveal key={i} y={16}>
              <section className="mb-12" data-testid={`privacidad-seccion-${i}`}>
                <h2 className="font-serif text-2xl text-ink-deep">{s.titulo}</h2>
                {s.parrafos.map((p, j) => (
                  <p key={j} className="mt-4 leading-relaxed text-ink-text">
                    {p}
                  </p>
                ))}
              </section>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}

import { Reveal } from "@/lib/motion";
